/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  CompanyRolePermission,
  CompanyRolePermissionFromJSON,
  CompanyRolePermissionFromJSONTyped,
  CompanyRolePermissionToJSON,
} from "./CompanyRolePermission";

/**
 *
 * @export
 * @interface CompanyEmployeeRolePermissionsDto
 */
export interface CompanyEmployeeRolePermissionsDto {
  /**
   *
   * @type {Array<CompanyRolePermission>}
   * @memberof CompanyEmployeeRolePermissionsDto
   */
  permissions: Array<CompanyRolePermission>;
}

export function CompanyEmployeeRolePermissionsDtoFromJSON(json: any): CompanyEmployeeRolePermissionsDto {
  return CompanyEmployeeRolePermissionsDtoFromJSONTyped(json, false);
}

export function CompanyEmployeeRolePermissionsDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CompanyEmployeeRolePermissionsDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    permissions: (json["permissions"] as Array<any>).map(CompanyRolePermissionFromJSON),
  };
}

export function CompanyEmployeeRolePermissionsDtoToJSON(value?: CompanyEmployeeRolePermissionsDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    permissions: (value.permissions as Array<any>).map(CompanyRolePermissionToJSON),
  };
}
